// @flow

import styled from "styled-components";

import buildColor from "../../_static/ColorPalette";

export const ChangesList = styled.ul`
  padding: 8px;
  margin: 0;
  list-style: none;
`;

export const ChangesDivisor = styled.li`
  padding: 16px 0;
  border-top: 1px solid ${buildColor("blue", "100")};
`;
